function normalize(str: string) {
  return str
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s]/gu, '')
    .replace(/\s+/g, ' ')
    .trim();
}

const synonyms: Record<string, string[]> = {
  'american express': ['amex'],
  amex: ['american express'],
  'կենսաթոշակային քարտ': ['pension'],
  բարերար: ['barerar'],
};

function expandWithSynonyms(str: string) {
  let result = normalize(str);

  for (const [key, values] of Object.entries(synonyms)) {
    const normalizedKey = normalize(key);

    if (result.includes(normalizedKey)) {
      result += ` ${values.map(normalize).join(' ')}`;
    }

    for (const value of values) {
      const normalizedValue = normalize(value);

      if (result.includes(normalizedValue)) {
        result += ` ${normalizedKey}`;
      }
    }
  }

  return result;
}

function getWords(str: string) {
  return [...new Set(expandWithSynonyms(str).split(' ').filter(Boolean))];
}

function getMatchScore(option: string, input: string, strict = false) {
  const normalizedOption = normalize(option);
  const normalizedInput = normalize(input);

  if (normalizedOption === normalizedInput) {
    return 1000;
  }

  const optionWords = getWords(option);
  const inputWords = new Set(getWords(input));

  const matchedWords = optionWords.filter((word) => inputWords.has(word));

  if (strict && matchedWords.length !== optionWords.length) {
    return 0;
  }

  if (!matchedWords.length) {
    return 0;
  }

  const coverage = matchedWords.length / optionWords.length;

  return coverage * 100 + matchedWords.length;
}

export const getMatchedCard = (
  title: string,
  options: string[],
  strict = false,
) => {
  const matches = options
    .map((option) => ({
      option,
      score: getMatchScore(option, title, strict),
    }))
    .filter(({ score }) => score > 0)
    .sort((a, b) => b.score - a.score);

  return matches[0]?.option ?? null;
};
